



















































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import {Getter, Mutation} from "vuex-class";
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import {FormRowWings, SmsTextInputWings, InputWings, TextareaWings} from 'wings-ui-components';
import { MsgTransports } from '@/store/types';
import { SmsTemplateItemImpl } from '@/store/templates/types';
import {cloneDeep} from "lodash";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {GenericTemplate, FormRowWings, SmsTextInputWings, InputWings, TextareaWings}})
export default class SmsTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate: any;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  private transport: MsgTransports = MsgTransports.SMS;
  private templateObject: SmsTemplateItemImpl = new SmsTemplateItemImpl();

  created() {
    this.setTemplate()
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  onLoadTemplate(template: any) {
    this.$emit('onLoadTemplate', template)
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    this.genericTemplate.beforeLeave(to,from,next)
  }
}
